import rootReducer from "./Reducer/index.ts";
import { createStore } from 'redux';

const store = createStore(rootReducer);

export default store;